import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
import { BiSolidTrashAlt } from "react-icons/bi";
import { HiMiniPencilSquare } from "react-icons/hi2";
import { useNavigate } from 'react-router-dom';
import { LIVE_URL } from '../../../../config/config';
import useAuthToken from '../../../../hooks/useAuthToken';
import CustomModel from "../../customModel/CustomModel";
import styles from './css/ProductTable.module.scss';

const ProductTable = ({ faqs, rows, setFaqs, currentPage, setCurrentPage, sortField, sortOrder, setSortField, setSortOrder }) => {
    const { token } = useAuthToken();
    const navigate = useNavigate();
    const [popupMessage, setPopupMessage] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedFaqId, setSelectedFaqId] = useState(null);

    useEffect(() => {
        let timer;
        if (popupMessage) {
            const popupElement = document.getElementById('popup-message');
            if (popupElement) {
                popupElement.style.opacity = '1';
            }
            timer = setTimeout(() => {
                if (popupElement) {
                    popupElement.style.opacity = '0';
                }
                setTimeout(() => {
                    setPopupMessage('');
                }, 500);
            }, 2000);
        }
        return () => clearTimeout(timer);
    }, [popupMessage]);

    const handleEdit = (id) => {
        navigate(`/home/add-faq/${id}`);
    };

    const handleDeleteClick = (id) => {
        setSelectedFaqId(id);
        setModalOpen(true);
    };

    const handleDeleteConfirm = async () => {
        setModalOpen(false);
        if (selectedFaqId !== null) {
            try {
                const response = await fetch(`${LIVE_URL}/admin/faq/delete/${selectedFaqId}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    setFaqs(prevFaqs => prevFaqs.filter(faq => faq.id !== selectedFaqId));
                    setPopupMessage(`FAQ deleted successfully`);
                } else {
                    setPopupMessage(`Failed to delete FAQ. Status: ${response.status}`);
                }
            } catch (error) {
                setPopupMessage('Error deleting FAQ.');

            }
        }
    };

    const columns = [
        { field: 'id', header: 'Sr No.', className: styles['column-id'], sortable: true },
        {
            field: 'question',
            header: 'Question',
            className: styles['column-question'],
            body: (rowData) => (
                <div className={styles['question-text']}>
                    {rowData.question}
                </div>
            ),
            sortable: false
        },
        {
            field: 'answer',
            header: 'Answer',
            className: styles['column-answer'],
            body: (rowData) => (
                <div className={styles['answer-text']}>
                    {rowData.answer}
                </div>
            ),
        },
        {
            field: 'status',
            header: 'FAQ Status',
            className: styles['column-status'],
            body: (rowData) => (
                <span className={rowData.status ? styles['status-published'] : styles['status-unpublished']}>
                    {rowData.status ? 'Publish' : 'Unpublish'}
                </span>
            ),
            sortable: true
        },
        {
            field: 'action',
            header: 'Action',
            className: styles['column-action'],
            body: (rowData) => (
                <div className={styles['action-icons']}>
                    <HiMiniPencilSquare className={styles['pencil-icon']} onClick={() => handleEdit(rowData.id)} />
                    <BiSolidTrashAlt className={styles['trash-icon']} onClick={() => handleDeleteClick(rowData.id)} />
                </div>
            ),
            sortable: false
        },
    ];

    const handlePageChange = (event) => {
        setCurrentPage(event.page + 1);
    };

    const handleSort = (event) => {
        setSortField(event.sortField);
        setSortOrder(event.sortOrder === 1 ? 'ASC' : 'DESC');
    };

    return (
        <>
            <div id="popup-message" className={`${styles.delete_message} ${popupMessage.includes('success') ? styles.success : styles.error}`}>
                {popupMessage && (
                    <p>{popupMessage}</p>
                )}
            </div>
            <div className={styles.main}>
                <DataTable
                    className={styles.datatable}
                    value={faqs}
                    rows={rows}
                    first={(currentPage - 1) * rows}
                    onPage={handlePageChange}
                    totalRecords={faqs.length}
                    sortField={sortField}
                    sortOrder={sortOrder === 'ASC' ? 1 : -1}
                    onSort={handleSort}
                    emptyMessage={<div className={styles['no-data-message']}>No data to display.</div>}
                >
                    {columns.map((col, i) => (
                        <Column
                            key={i}
                            field={col.field}
                            header={col.header}
                            sortable={col.sortable}
                            headerClassName={`${styles['column-header-small']} ${col.className}`}
                            bodyClassName={col.className}
                            body={col.body}
                            handleSort={handleSort}
                        />
                    ))}
                </DataTable>
            </div>
            <CustomModel
                isOpen={modalOpen}
                onRequestClose={() => setModalOpen(false)}
                onConfirm={handleDeleteConfirm}
            />
        </>
    );
};

export default ProductTable;